const ROUTE_SESSION_STATUS = {
    ACTIVE: 'active',
    CLOSED: 'closed',
    INACTIVE: 'inactive',
    PREPARING_LOAD: 'preparing_load',
    AWAITING_PICKUP: 'awaiting_pickup',
    IN_TRANSIT: 'in_transit',
    AWAITING_DROPOFF: 'awaiting_dropoff',
    DELIVERY_IN_PROGRESS: 'delivery_in_progress',
    MANUAL_ADJUSTMENT: 'manual_adjustment',
    CANCELLED: 'cancelled',
    AWAITING_OFFLOAD: 'awaiting_offload',
    AWAITING_PICKUP_RAPID_TEST: 'awaiting_pickup_rapid_test',
    PICKUP_RAPID_TEST_COMPLETE: 'pickup_rapid_test_complete',
    PICKUP_RAPID_TEST_AWAITING_QA: 'pickup_rapid_test_awaiting_qa',
    PICKUP_RAPID_TEST_FAILED: 'pickup_rapid_test_failed',
    DROPOFF_RAPID_TEST_COMPLETE: 'dropoff_rapid_test_complete',
    DROPOFF_RAPID_TEST_AWAITING_QA: 'dropoff_rapid_test_awaiting_qa',
    DROPOFF_RAPID_TEST_FAILED: 'dropoff_rapid_test_failed',
    // Prettier No Prettying
};

export const PROCESSED_FLUID_ROUTE_SESSION_STATUS_LABELS = {
    [ROUTE_SESSION_STATUS.ACTIVE]: 'Active',
    [ROUTE_SESSION_STATUS.CLOSED]: 'Closed',
    [ROUTE_SESSION_STATUS.INACTIVE]: 'Inactive',
    [ROUTE_SESSION_STATUS.PREPARING_LOAD]: 'Preparing Load',
    [ROUTE_SESSION_STATUS.AWAITING_PICKUP]: 'Awaiting Pickup',
    [ROUTE_SESSION_STATUS.IN_TRANSIT]: 'In Transit',
    [ROUTE_SESSION_STATUS.AWAITING_DROPOFF]: 'Awaiting Dropoff',
    [ROUTE_SESSION_STATUS.DELIVERY_IN_PROGRESS]: 'Delivery In Progress',
    [ROUTE_SESSION_STATUS.MANUAL_ADJUSTMENT]: 'Manual Adjustment',
    [ROUTE_SESSION_STATUS.CANCELLED]: 'Cancelled',
    [ROUTE_SESSION_STATUS.AWAITING_OFFLOAD]: 'Awaiting Offload',
    [ROUTE_SESSION_STATUS.AWAITING_PICKUP_RAPID_TEST]: 'Awaiting Pickup Rapid Test',
    [ROUTE_SESSION_STATUS.PICKUP_RAPID_TEST_COMPLETE]: 'Pickup Rapid Test Complete',
    [ROUTE_SESSION_STATUS.PICKUP_RAPID_TEST_AWAITING_QA]: 'Pickup Rapid Test Awaiting QA',
    [ROUTE_SESSION_STATUS.PICKUP_RAPID_TEST_FAILED]: 'Pickup Rapid Test Failed',
    [ROUTE_SESSION_STATUS.DROPOFF_RAPID_TEST_COMPLETE]: 'Dropoff Rapid Test Complete',
    [ROUTE_SESSION_STATUS.DROPOFF_RAPID_TEST_AWAITING_QA]: 'Dropoff Rapid Test Awaiting QA',
    [ROUTE_SESSION_STATUS.DROPOFF_RAPID_TEST_FAILED]: 'Dropoff Rapid Test Failed',
};

export const POST_PICKUP_ROUTE_SESSION_STATUSES = [
    ROUTE_SESSION_STATUS.AWAITING_DROPOFF,
    ROUTE_SESSION_STATUS.AWAITING_PICKUP_RAPID_TEST,
    ROUTE_SESSION_STATUS.PICKUP_RAPID_TEST_COMPLETE,
    ROUTE_SESSION_STATUS.PICKUP_RAPID_TEST_AWAITING_QA,
    ROUTE_SESSION_STATUS.PICKUP_RAPID_TEST_FAILED,
    // Prettier No Prettying
];

const titleCaseStatus = (status) =>
    String(status)
        .split('_')
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

export const getProcessedFluidRouteSessionStatusLabel = (status, localization) => {
    if (!status) return null;
    return localization?.processed_fluids?.status?.[status] ?? PROCESSED_FLUID_ROUTE_SESSION_STATUS_LABELS[status] ?? titleCaseStatus(status);
};

export default ROUTE_SESSION_STATUS;
